// Quién entra a una ruta protegida — usado por components/ProtectedRoute.js.
//
// Seguridad Fase 3 (project-log/initiatives/active/admin-mentor-integracion.md,
// sección G): `adminOnly` dejaba pasar también a los mentores (isAdmin || isTutor),
// así que un mentor podía abrir todo /admin. Ahora `adminOnly` es solo admin.

export function hasRouteAccess({ isAdmin, isTutor, adminOnly = false, requiredRole }) {
  if (requiredRole) {
    switch (requiredRole) {
      case 'admin':
        return Boolean(isAdmin);
      case 'tutor':
        return Boolean(isAdmin || isTutor);
      case 'student':
        return true;
      default:
        return false;
    }
  }
  if (adminOnly) return Boolean(isAdmin);
  return true;
}

// A dónde se manda a quien no tiene acceso: un mentor vuelve a su portal.
export function deniedRedirectPath({ isTutor }) {
  return isTutor ? '/mentor' : '/fluency-compass';
}
